import { getEventProfileRequest } from '~admin/view/components/create-event/helper/event-profile-request.helper';
import { EventFormData } from '~admin/view/components/details/event-form-data';
import { EventProfileUpdateRequest } from '~client/model/admin/event-profile-update-request';

/**
 * Transforms CreateEventFormData to EventProfileCreateRequest
 * @param eventId
 * @param values
 */
export const getEventProfileUpdateRequest = (
  eventId: number,
  values: EventFormData,
): EventProfileUpdateRequest => {
  return {
    id: eventId,
    ...getEventProfileRequest(values),
  };
};



// WEBPACK FOOTER //
// ./view/components/edit-event/helper/event-profile-update-request.helper.ts